import { render, staticRenderFns } from "./PlantPopupAd.vue?vue&type=template&id=30223132"
import script from "./PlantPopupAd.vue?vue&type=script&lang=js"
export * from "./PlantPopupAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports